// One day's drill-in (`/accounts/day/:date`, design `#s02` day tap target).
// No M1 endpoint (execution plan §9 conflict #9): `useDaySummary` resolves
// to `unavailable` against the real API, and this route renders a neutral
// unsupported-history state rather than a fabricated day total.
import { Link, useLocation, useParams } from 'react-router-dom';
import { useShellContext } from '@/app/shell/AppShell';
import { RouteRecoveryScreen } from '@/app/states/RouteStates';
import { DateScopeGuard } from '@/app/shell/DateScopeGuard';
import { scopeHref } from '@/app/shell/scope';
import { formatHumanDate, isStrictCalendarDate } from '@/lib/date';

function formatDayDate(date: string): string {
  return formatHumanDate(date, { includeYear: false });
}

function trendHref(search: string, hash: string): string {
  const scoped = scopeHref(`/accounts/trend${hash}`, search);
  const hashIndex = scoped.indexOf('#');
  const scopedPath = hashIndex >= 0 ? scoped.slice(0, hashIndex) : scoped;
  const scopedHash = hashIndex >= 0 ? scoped.slice(hashIndex) : '';
  const params = new URLSearchParams(scopedPath.split('?')[1] ?? '');
  for (const [key, value] of new URLSearchParams(search)) {
    if (key !== 'from' && key !== 'to' && key !== 'account' && key !== 'scope') params.append(key, value);
  }
  const query = params.toString();
  return `${scopedPath.split('?')[0]}${query ? `?${query}` : ''}${scopedHash}`;
}

export function DayPage() {
  const { date } = useParams<{ date: string }>();
  const { dateScopeAvailability } = useShellContext();
  const location = useLocation();
  const validDate = isStrictCalendarDate(date);
  return (
    <section aria-labelledby="day-heading" className="mx-auto max-w-2xl px-4 py-6">
      <Link to={trendHref(location.search, location.hash)} className="flex min-h-11 items-center text-sm text-link">
        ‹ Trend
      </Link>
      <h1 id="day-heading" tabIndex={-1} className="mt-2 text-title font-semibold" data-testid="day-heading">
        {validDate ? <><span aria-hidden="true">{formatDayDate(date)}</span><span className="sr-only">{date}</span></> : 'Day detail'}
      </h1>
      {validDate ? <DateScopeGuard availability={dateScopeAvailability}><p role="status" className="rounded-md border border-degraded-border bg-degraded-surface p-4 text-sm text-degraded-foreground">Net worth history is not available yet.</p></DateScopeGuard> : <RouteRecoveryScreen kind="not-found" frame="inline" />}
    </section>
  );
}

export default DayPage;
